export enum UploadFileName {
  logoCustomer = 'CustomerLogo',
  logoUo = 'UELogo',
  logoProjet = 'ProjectLogo',
  logoCustomerFile = 'logoCustomer',
  logoUoFile = 'logoUE',
  logoProjetFile = 'logoProject'
}
